import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";


const Register = ({ className }) => {
	//const history = useHistory();


	return(
		<div className={className}>
			<div className="reg-form">
				<iframe 
				src={"https://matchbox.redpodium.com/cais2021registration"} 
				width="100%"
				height="2500px"
				frameborder="0"
				border="0"
				scrolling="yes"
				padding-bottom="50px"
				>

				</iframe>
			</div>

		</div>
		
	);
};

export default styled(Register)`
	display: flex;
	// flex-direction: column;
	// background: #ffffffad;
	flex-direction: column;
	//width: 1000px;
	margin: auto;

	.reg-form{
		// width: 1000px;
        /* overflow:hidden; */
        
        iframe{
            height: 2500px;
            width: 100%;
        }
	};

	@media screen and (min-width: 320px) and (max-width: 425px){
		.reg-form{
			width: 320px;
			height: 2800px;
		}
		
		
	}

`;


